// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable no-restricted-imports */
import { type GroupChannel } from "@sendbird/chat/groupChannel";
import { useAppSelector } from "@src/app/store";
import { setChannels } from "@src/app/store/chat";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { type Dispatch } from "redux";

/**
 * @deprecated
 * This hook is deprecated and should not be used.
 * It is used to set the channels in the redux store.
 * This is done to be compatible with appV1 chat channels implementation.
 */
export function useDeprecatedChatChannelStore() {
  const dispatch = useDispatch<Dispatch>();
  const channels = useAppSelector((store) => store.chatStore.channels);

  const memoizedSetChannels = useCallback(
    async (channels: GroupChannel[]) => {
      await setChannels(dispatch, channels);
    },
    [dispatch]
  );

  return {
    channels,
    setChannels: memoizedSetChannels,
  };
}
